// namespace
window.Components = window.Components || {};

import domReady from '@wordpress/dom-ready';

(function($) {

  'use strict';

  function videoHtml() {

    const self = this,
        $cache = {};

    /**
     * Init Cache
     *
     * @param  {Object} target jQuery-wrapped root element
     */
    function initCache(target) {
        $cache.videoHtml = target;
        $cache.html = $('html');

        $cache.play = $cache.videoHtml.find('.play');
        $cache.close = $cache.videoHtml.find('.close');

        $cache.modal = $cache.videoHtml.find('.modal-video');
        $cache.modalBg = $cache.modal.find('.modal-bg');

        $cache.video = $cache.modal.find('video');
        $cache.itemContainer = $cache.videoHtml.closest('.item');
        $cache.lengthValue = $cache.itemContainer.find('.length-value');
    }

    function toggleModal() {
      if ($cache.isOpen) {
        closeModal();
      } else {
        openModal();
      }
    }

    function openModal() {
      if ($cache.isOpen) return;

      $cache.isOpen = true;
      $cache.modal.addClass('is-active');
      $cache.html.addClass('scroll-disabled');
    }

    function closeModal() {
      if (!$cache.isOpen) return;

      $cache.isOpen = false;
      $cache.modal.removeClass('is-active');
      $cache.html.removeClass('scroll-disabled');
    }

    function initVidLength() {
      const time = $cache.video[0].duration;

      const min = Math.floor(time / 60);
      let seconds = Math.floor(time - min * 60);

      if (seconds < 10) seconds = '0' + seconds;

      $cache.lengthValue.text(min + ':' + seconds);
    }

    /**
     * Register Events
     */
    function registerEvents() {

        $cache.play.on('click', function() {
            toggleModal();
        });

        $cache.close.on('click', function() {
            toggleModal();
        });

        $cache.modalBg.on('click', function() {
            closeModal();
        });

        $cache.video.on('loadedmetadata', function() {
            initVidLength();
        });
    }

    /**
     * Public constructor
     *
     * @param  {Object} target jQuery-wrapped root element
     */
    self.initialize = function(target) {
        initCache(target);
        registerEvents();

        $cache.isOpen = false;
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  window.Components.videoHtml = videoHtml;

  domReady(() => {
    $('[data-component="videoHtml"]').each(function() {
      new window.Components.videoHtml($(this));
    });
  });

}(jQuery));
